import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'atlasai/memories'

export const LIST_MEMORIES = createRequestTypes(prefix, 'LIST_MEMORIES')
export const [LIST_MEMORIES_REQUEST, LIST_MEMORIES_SUCCESS, LIST_MEMORIES_FAILURE] = LIST_MEMORIES

export const listMemories = createAction((params?: object) => ({
  type: LIST_MEMORIES,
  promise: (api: IApi) => api.atlasAI.listMemories(params),
  params,
}))

export const GET_MEMORY = createRequestTypes(prefix, 'GET_MEMORY')
export const [GET_MEMORY_REQUEST, GET_MEMORY_SUCCESS, GET_MEMORY_FAILURE] = GET_MEMORY

export const getMemory = createAction((id: string) => ({
  type: GET_MEMORY,
  promise: (api: IApi) => api.atlasAI.getMemory(id),
}))

export const ADD_MEMORY = createRequestTypes(prefix, 'ADD_MEMORY')
export const [ADD_MEMORY_REQUEST, ADD_MEMORY_SUCCESS, ADD_MEMORY_FAILURE] = ADD_MEMORY

export const addMemory = createAction((data: object) => ({
  type: ADD_MEMORY,
  promise: (api: IApi) => api.atlasAI.addMemory(data),
}))

export const UPDATE_MEMORY = createRequestTypes(prefix, 'UPDATE_MEMORY')
export const [UPDATE_MEMORY_REQUEST, UPDATE_MEMORY_SUCCESS, UPDATE_MEMORY_FAILURE] = UPDATE_MEMORY

export const updateMemory = createAction((id: string, data: object) => ({
  type: UPDATE_MEMORY,
  promise: (api: IApi) => api.atlasAI.updateMemory(id, data),
}))

export const DELETE_MEMORY = createRequestTypes(prefix, 'DELETE_MEMORY')
export const [DELETE_MEMORY_REQUEST, DELETE_MEMORY_SUCCESS, DELETE_MEMORY_FAILURE] = DELETE_MEMORY

export const deleteMemory = createAction((id: string) => ({
  type: DELETE_MEMORY,
  promise: (api: IApi) => api.atlasAI.deleteMemory(id),
}))

export const RESOLVE_MEMORY_FLAGS = createRequestTypes(prefix, 'RESOLVE_MEMORY_FLAGS')
export const [
  RESOLVE_MEMORY_FLAGS_REQUEST,
  RESOLVE_MEMORY_FLAGS_SUCCESS,
  RESOLVE_MEMORY_FLAGS_FAILURE,
] = RESOLVE_MEMORY_FLAGS

export const resolveMemoryFlags = createAction((id: string) => ({
  type: RESOLVE_MEMORY_FLAGS,
  promise: (api: IApi) => api.atlasAI.resolveMemoryFlags(id),
}))

export const CLEAR_SELECTED_MEMORY = `${prefix}/CLEAR_SELECTED_MEMORY`

export const clearSelectedMemory = () => ({ type: CLEAR_SELECTED_MEMORY })
